// React
import React from 'react';
// External
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import CustomiseTextComponent from 'components/engraving/CustomiseText/CustomiseText';
import FooterBtnActions from 'components/shared/molecules/FooterBtnActions/FooterBtnActions';
import { updateEngraving } from 'stores/actions';

class CustomiseText extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.formComponent = React.createRef();
    }

    componentDidMount() {
    }

    async onSubmit() {
        if (!this.formComponent || !this.formComponent.current) {
            return null;
        }
        const formData = await this.formComponent.current.handleSubmit();
        if (formData) {
            this.props.updateEngraving(formData);
            this.navigateTo('/engraving/engraving-options', {
                engraving: this.props.engraving
            });
        }
    }

    navigateTo(path) {
        this.props.history.push({
            pathname: path,
            search: this.props.location.search
        });
    }

    render() {
        return (
            <div className="main-container">
                <NavbarPrimary hideNav />
                <div className="body-content engraving">
                    <PageTitle title="Engraving approval" />
                    <ContentCard
                        className="mt-62"
                        headerTitle="Customise Text"
                        divider={false}
                    >
                        <Container fluid className="engraving-container customise-text-container">
                            <CustomiseTextComponent
                                wrappedComponentRef={this.formComponent}
                            />
                        </Container>
                    </ContentCard>
                </div>

                <FooterBtnActions
                    nextBtnOnCLick={() => this.onSubmit()}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    engraving: state.engraving
});

const mapDispatchToProps = (dispatch) => {
    return {
        updateEngraving: (engravingObj) => dispatch(updateEngraving(engravingObj))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomiseText));
